// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__dkFAk","label":"styles_label__1cGjM","fileInput":"styles_fileInput__3HjP3","button":"styles_button__xzu5F","image":"styles_image__3qdoo"};